<template>
  <div v-if="userId">
    <div v-if="isLoading" class="text-center">
      <ProgressSpinner />
    </div>
    <div v-else>
      <DataTable :value="data" class="p-datatable-sm p-datatable-gridlines" scrollHeight="155px" autoLayout>
        <Column header="ID" field="dept_id" headerStyle="text-align: center;" />
        <Column header="Подразделение" field="dept_name" headerStyle="text-align: center;" />
        <Column header="Признак" bodyStyle="text-align: center;" headerStyle="text-align: center;">
          <template #body="slotProps">
            <Checkbox v-model="slotProps.data.includ" binary :disabled="!permissions.setting"
              @change="onChange(slotProps.data)" />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, defineProps } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';

const props = defineProps({
  userId: {
    type: Number,
    default: null,
  },
  permissions: {
    type: Object,
    default: () => ({}),
  },
});

const store = useStore();
const toast = useToast();

const isLoading = ref(false);
const data = ref(null);
const userDeptService = ref(null);

const initService = () => {
  if (!userDeptService.value) {
    userDeptService.value = store.getters.nameToService(
      'BaseService',
      store.getters.info.login,
      store.getters.info.password,
      'user_dept',
      'data'
    );
  }
};

const getUserDept = () => {
  if (!props.userId || props.userId < 0) {
    data.value = [];
    return;
  }
  isLoading.value = true;
  if (!userDeptService.value) {
    initService();
  }
  userDeptService.value
    .getData({ user_id: props.userId })
    .then((res) => {
      data.value = res;
    })
    .catch((er) =>
      store.commit('SET_ERROR', {
        er: er.response || er,
        source: ['UserDept', 'userId', 'getData'],
      })
    )
    .finally(() => {
      isLoading.value = false;
    });
};

const onChange = (row) => {
  const payload = {
    user_id: row.user_id ?? props.userId,
    dept_id: row.dept_id,
    includ: row.includ,
  };
  if (!userDeptService.value) {
    initService();
  }
  userDeptService.value
    .putData(payload)
    .then(() => {
      toast.add({
        severity: 'success',
        summary: 'Подразделение обновлено',
        detail: 'Назначение пользователя в подразделение успешно применено',
        life: 2000,
      });
      getUserDept();
    })
    .catch((er) => {
      store.commit('SET_ERROR', {
        er,
        source: ['UserDept', 'onChange', 'update'],
      });
    });
};

onMounted(() => {
  initService();
  if (props.userId) {
    getUserDept();
  }
});

watch(
  () => props.userId,
  (newVal) => {
    if (newVal) {
      getUserDept();
    } else {
      data.value = null;
    }
  }
);
</script>

<style lang="scss" scoped>
.image-text {
  vertical-align: middle;
}

.p-treetable .p-treetable-tbody>tr>td {
  padding: 0.2rem 0.2rem !important;
}
</style>